import { axiosWithToken } from "./axiosService";

export const getRoleList = async () => {
    try {
        const response = await axiosWithToken().get("api/role/");
        return response.data;
    } catch (err) {
        throw err;
    }
}